<template>
    <div class="left-box">
        <title1 title="站点信息" subTitle="Site Information" />
        <div class="info-box mt-100">
            <div>
                <div class="info-item">
                    <div class="item-label">站点名称：</div>
                    <div class="item-value">{{ stationInfo.stationName }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">建站日期：</div>
                    <div class="item-value">{{ stationInfo.stationType }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label flex justify-between"><span>省</span><span>市：</span></div>
                    <div class="item-value">{{ stationInfo.city }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">开站日期：</div>
                    <div class="item-value">{{ stationInfo.creationDate }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">占地面积：</div>
                    <div class="item-value">{{ stationInfo.coverAnArea }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">服务能力：</div>
                    <div class="item-value">{{ stationInfo.stationServiceQuality }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">匹配车型：</div>
                    <div class="item-value">{{ stationInfo.vehicleBrand }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">站点类型：</div>
                    <div class="item-value">{{ stationInfo.stationType }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">车位数量：</div>
                    <div class="item-value">{{ stationInfo.parkingPlace }}</div>
                </div>
            </div>
            <div>
                <div class="info-item">
                    <div class="item-label">电池数量：</div>
                    <div class="item-value">{{ stationInfo.houseTotalBatteries }}</div>
                </div>
            </div>
        </div>
        <div class="flex justify-between mt-10">
            <div
                v-for="(item, i) in target1"
                :key="'target1' + i"
                class="flex flex1 flex-direction align-center target1 mt-30">
                <span class="label2">{{ item.label }}</span>
                <div style="position: relative;">
                    <span class="label1">{{ item.number }}</span>
                    <img class="img1 mt-15" :src="require('@/assets/images/exposition/chd-bg-2.png')" alt="">
                </div>
            </div>
        </div>

        <title1 class="mt-100" title="运营指标" subTitle="Operation Index" />
        <div class="flex flex-wrap mt-40">
            <div
                v-for="(item, i) in target2"
                :key="'target1' + i"
                class="flex align-center justify-center target2 target2-1 mt-35 width-50">
                <img class="img" :src="require('@/assets/images/exposition/chd-bg-4.png')" alt="">
                <div>
                    <div class="label">{{ item.label }}</div>
                    <div class="num flex justify-center mt-15">{{ item.number }}</div>
                </div>
            </div>
        </div>

        <title1 class="mt-70" type="2" title="换电订单数及负荷率" />
        <div class="box-1 mt-15">
            <myEchart
                v-if="orderAndloadRateShow"
                id="orderAndloadRate"
                :options="orderAndloadRateOptions" />
        </div>
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
import { dataInterface } from "@/api/dataInterfaceApi"
import myEchart from '@/views/exposition/components/charts/echarts'
import * as echarts from 'echarts5'
export default {
    components: {
        title1,
        myEchart
    },
    data() {
        let { stationId } = this.$route.query || {}
        return {
            stationInfo: {},
            stationId: stationId,
            target1: [
                {
                    number: '',
                    label: '充电中'
                },
                {
                    number: '',
                    label: '可用'
                },
                {
                    number: '',
                    label: '其他'
                },
            ],
            target2: [
                {
                    number: '100%',
                    label: '本月换电里程(km)'
                },
                {
                    number: '100%',
                    label: '本月换电次数(次)'
                },
                {
                    number: '100%',
                    label: '本月充电电量(kwh)'
                },
                {
                    number: '100%',
                    label: '本月充电成本(元)'
                },
            ],
            orderAndloadRateShow: false,
            orderAndloadRateOptions: {}
        }
    },
    methods: {
        getData(data) {
            // 站点信息
            this.getSataionInfo(data)
            // 可用电池数
            this.keyongdianchishu(data)
            // 可用电池数
            this.chongdiandianliang(data)
            // 电池需求及负荷率
            this.dianchixuqiujihefuhelv(data)
        },
        // 站点信息
        getSataionInfo(data = {}) {
            let params = {
                'enCode': 'TiDB-zhandian-zhandianxinxixia',
                '@station_id': this.stationId
            }
            dataInterface.dataFaceApi(params).then( res => {
                this.stationInfo = res && res[0] || {}
            })
        },

        // 可用电池数
        keyongdianchishu(data = {}) {
            let params = {
                'enCode': 'TiDB-zhandian-keyongdianchishu',
                '@station_id': this.stationId
            }
            dataInterface.dataFaceApi(params).then( res => {
                let data = res && res[0] || {}
                this.target1[0].number = data.battertNameNumCharging || '0'
                this.target1[1].number = data.battertNameNumFinish || '0'
                this.target1[2].number = data.battertNameNumOther || '0'
            })
        },

        // 站点充电电量
        chongdiandianliang(data = {}) {
            let params = {
                'enCode': 'TiDB-zhandian-chongdiandianliang',
                '@station_id': this.stationId
            }
            dataInterface.dataFaceApi(params).then( res => {
                let data = res && res[0] || {}
                this.target2[0].number = data.battery_mileage || '0'
                this.target2[1].number = data.power_exchange_num || '0'
                this.target2[2].number = data.totalelect || '0'
                this.target2[3].number = data.charge_cost || '0'
            })
        },

        // 电池需求及负荷率
        dianchixuqiujihefuhelv(data = {}) {
            let params = {
                'enCode': 'TiDB-zhandian-dianchixuqiujihefuhelv',
                '@station_id': this.stationId
            }
            dataInterface.dataFaceApi(params).then( res => {
                if(!res || !res.length) return
                this.orderAndloadRateShow = false
                let xData = []
                let yData1 = []
                let yData2 = []
                res.map(item => {
                    xData.push(item.hour_num)
                    yData1.push(item.frequency)
                    yData2.push(item.station_rate)
                })
                this.orderAndloadRateOptions = {
                    xAxis: [
                        {
                            type: 'category',
                            data: xData,
                            axisPointer: {
                                type: 'shadow'
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            name: '订单数',
                            min: 0,
                            // max: 250,
                            // interval: 50,
                            axisLabel: {
                                formatter: '{value} 单'
                            }
                        },
                        {
                            type: 'value',
                            name: '负荷量',
                            min: 0,
                            // max: 25,
                            // interval: 5,
                            axisLabel: {
                                formatter: '{value} %'
                            }
                        }
                    ],
                    series: [
                        {
                            name: '订单数',
                            type: 'bar',
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 单';
                                }
                            },
							lineStyle: {
								color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: 'rgba(11, 185, 229, 0)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(14, 202, 250, 1)'
                                }])
							},
                            data: yData1
                        },
                        {
                            name: '负荷率',
                            type: 'line',
                            yAxisIndex: 1,
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' %';
                                }
                            },
							lineStyle: {
								color: '#FFD15C'
							},
                            data: yData2
                        }
                    ]
                }
                this.orderAndloadRateShow = true
            })
        }

    }
}
</script>

<style lang="scss" scoped>
@import '../scss/chd-com.scss';
</style>